export const css = `
  :host {
    all: initial;
    --hl-primary: #111;
    --hl-on-primary: #fff;
    --hl-font: -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    --hl-radius: 14px;
  }
  *, *::before, *::after { box-sizing: border-box; }

  .root {
    position: fixed;
    z-index: 2147483646;
    font: 14px/1.4 var(--hl-font);
    color: #111;
  }
  .root.br { right: 20px; bottom: 20px; }
  .root.bl { left: 20px;  bottom: 20px; }

  .fab {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 18px 12px 14px;
    background: var(--hl-primary);
    color: var(--hl-on-primary);
    border: none;
    border-radius: 999px;
    cursor: pointer;
    box-shadow: 0 6px 20px rgba(0,0,0,.18), 0 2px 6px rgba(0,0,0,.10);
    font: 600 14px/1 var(--hl-font);
    transition: transform .15s ease, box-shadow .15s ease, filter .15s ease;
    animation: pop .35s ease-out;
  }
  .fab:hover { transform: translateY(-1px); box-shadow: 0 10px 24px rgba(0,0,0,.22); filter: brightness(.92); }
  .fab .ico {
    width: 22px; height: 22px; border-radius: 50%;
    background: rgba(255,255,255,.18);
    display: inline-flex; align-items: center; justify-content: center;
    font-size: 14px;
  }
  .fab.done { background: #10b981; cursor: default; }
  .fab.done:hover { transform: none; filter: none; }

  .panel {
    width: 340px;
    max-width: calc(100vw - 32px);
    background: #fff;
    border-radius: var(--hl-radius);
    box-shadow: 0 24px 60px rgba(0,0,0,.22), 0 4px 14px rgba(0,0,0,.10);
    overflow: hidden;
    animation: slideUp .22s ease-out;
    font: 14px/1.4 var(--hl-font);
  }
  .root.br .panel { transform-origin: bottom right; }
  .root.bl .panel { transform-origin: bottom left; }

  .head {
    padding: 16px 18px 12px;
    background: var(--hl-primary);
    color: var(--hl-on-primary);
    position: relative;
  }
  .head h2 { margin: 0; font-size: 15px; font-weight: 600; }
  .head .sub { margin: 4px 0 0; font-size: 13px; opacity: .82; }
  .head .hero {
    display: block; width: 100%; height: auto; max-height: 160px;
    object-fit: cover; border-radius: 10px; margin: 0 0 12px;
  }
  .head .close {
    position: absolute; top: 10px; right: 10px;
    width: 28px; height: 28px; border-radius: 50%;
    background: rgba(255,255,255,.12); color: var(--hl-on-primary);
    border: none; cursor: pointer; font-size: 16px; line-height: 1; z-index: 1;
  }
  .head .close:hover { background: rgba(255,255,255,.22); }

  .body { display: flex; flex-direction: column; gap: 10px; padding: 16px 18px 14px; }
  .step { display: flex; flex-direction: column; gap: 10px; }
  .progress { font-size: 11px; font-weight: 600; color: #999; text-transform: uppercase; letter-spacing: .03em; }
  label { display: flex; flex-direction: column; gap: 4px; font-size: 12px; color: #555; }
  label.check { flex-direction: row; align-items: flex-start; gap: 8px; font-size: 13px; color: #444; cursor: pointer; }
  label.check input { width: auto; margin-top: 2px; accent-color: var(--hl-primary); flex: none; }
  input, textarea, select {
    font: inherit; padding: 9px 11px; border: 1px solid #d6d6d6; border-radius: 8px;
    color: #111; background: #fff; outline: none; transition: border .15s, box-shadow .15s;
  }
  input:focus, textarea:focus, select:focus {
    border-color: var(--hl-primary);
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--hl-primary) 15%, transparent);
  }
  input.invalid, textarea.invalid, select.invalid { border-color: #ef4444; }
  textarea { min-height: 64px; resize: vertical; font-family: inherit; }

  .nav { display: flex; gap: 8px; margin-top: 4px; }
  button.submit {
    flex: 1;
    padding: 11px 14px;
    background: var(--hl-primary); color: var(--hl-on-primary);
    border: none; border-radius: 8px;
    font: 600 14px/1 var(--hl-font);
    cursor: pointer; transition: filter .15s;
  }
  button.submit:hover { filter: brightness(.92); }
  button.submit:disabled { filter: grayscale(.6) opacity(.7); cursor: not-allowed; }
  button.back {
    padding: 11px 14px; background: #f1f1f1; color: #555;
    border: none; border-radius: 8px; font: 600 14px/1 var(--hl-font);
    cursor: pointer; transition: filter .15s;
  }
  button.back:hover { filter: brightness(.96); }
  button.back:disabled { opacity: .6; cursor: not-allowed; }

  .err {
    background: #fef2f2; color: #b91c1c;
    padding: 9px 11px; border-radius: 8px;
    font-size: 13px; margin-top: 2px;
  }

  /* Mode inline : le formulaire est posé directement dans la page. */
  .root.inline { position: static; z-index: auto; width: 100%; }
  .root.inline .panel {
    width: 100%; max-width: 520px; margin: 0 auto;
    animation: none;
    box-shadow: 0 1px 3px rgba(0,0,0,.08), 0 0 0 1px rgba(0,0,0,.04);
  }

  .ok {
    text-align: center; padding: 28px 22px 22px;
  }
  .ok .check {
    width: 52px; height: 52px; border-radius: 50%;
    background: #10b981; color: #fff;
    display: inline-flex; align-items: center; justify-content: center;
    font-size: 28px; margin-bottom: 12px;
  }
  .ok h3 { margin: 0 0 6px; font-size: 16px; font-weight: 600; }
  .ok p  { margin: 0; color: #666; font-size: 13px; }

  .footer {
    padding: 8px 14px 12px; text-align: center;
    font-size: 11px; color: #aaa;
    border-top: 1px solid #f0f0f0; background: #fafafa;
  }
  .footer a { color: #888; text-decoration: none; }
  .footer a:hover { text-decoration: underline; }

  @keyframes pop {
    0%   { transform: scale(.7); opacity: 0; }
    70%  { transform: scale(1.06); opacity: 1; }
    100% { transform: scale(1); }
  }
  @keyframes slideUp {
    from { transform: translateY(8px) scale(.96); opacity: 0; }
    to   { transform: translateY(0)   scale(1);   opacity: 1; }
  }

  @media (max-width: 480px) {
    .panel { width: calc(100vw - 24px); }
    .root.br { right: 12px; bottom: 12px; }
    .root.bl { left: 12px;  bottom: 12px; }
  }
`;
